import React from 'react';
import { Clock, Calendar, MapPin, Users, Target, Award } from 'lucide-react';

const ServicesDetails = ({ listing }) => {
  const details = listing.specialized_data || {};
  
  if (!details || details._type !== 'services') return null;

  const specs = [
    { icon: Clock, label: 'Service Type', value: details.service_type },
    { icon: Clock, label: 'Duration', value: details.duration },
    { icon: Calendar, label: 'Availability', value: details.availability },
    { icon: MapPin, label: 'Service Area', value: details.service_area },
    { icon: Users, label: 'Team Size', value: details.team_size },
    { icon: Award, label: 'Experience', value: details.experience_yeaars },
    { icon: Calendar, label: 'Pricing Type', value: details.pricing_type },
  ];

  const features = [
    { label: 'Certified', value: details.is_certified },
    { label: 'Insured', value: details.is_insured },
    { label: 'Emergency Service', value: details.emergency_service },
    { label: 'Free Consultation', value: details.free_consultation },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Service Details</h2>
      
      {/* Basic Specs */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        {specs.map((spec, index) => {
          if (!spec.value) return null;
          return (
            <div key={index} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <spec.icon className="w-5 h-5 text-purple-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-500">{spec.label}</p>
                <p className="font-medium text-gray-900">{spec.value}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Features */}
      {features.filter(f => f.value).length > 0 && (
        <div className="mb-6">
          <h3 className="font-medium text-gray-900 mb-3">Features</h3>
          <div className="flex flex-wrap gap-2">
            {features.map((feature, index) => {
              if (!feature.value) return null;
              return (
                <span 
                  key={index} 
                  className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-purple-100 text-purple-800"
                >
                  {feature.label}
                </span>
              );
            })}
          </div>
        </div>
      )}

      {/* Pricing & Requirements */}
      {(details.price_range || details.payment_methods || details.requirements) && (
        <div className="border-t pt-4">
          <h3 className="font-medium text-gray-900 mb-3">Additional Information</h3>
          <div className="space-y-3">
            {details.price_range && (
              <div>
                <p className="text-sm text-gray-500">Price Range</p>
                <p className="font-medium text-gray-900">{details.price_range}</p>
              </div>
            )}
            {details.payment_methods && (
              <div>
                <p className="text-sm text-gray-500">Payment Methods</p>
                <p className="font-medium text-gray-900">{details.payment_methods}</p>
              </div>
            )}
            {details.requirements && (
              <div>
                <p className="text-sm text-gray-500">Requirements</p>
                <p className="font-medium text-gray-900 whitespace-pre-line">{details.requirements}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesDetails;